import { api } from './client'

/**
 * Canvass PROMO SKY letto dal server (PDF mensile dei dealer su Drive, tradotto in promo dall'IA ogni volta che cambia).
 * Le promo si filtrano nel frontend per cosa si attiva, tipo di cliente e rete di copertura (lib/skyPromo.ts).
 */
export interface SkyPromo {
  codice: string
  offerta: string
  tipologia: 'TV' | 'FISSO' | 'TV_FISSO' | 'ALTRO'
  segmento: 'RESIDENZIALE' | 'BUSINESS' | 'ENTRAMBI'
  rete: 'OPEN_FIBER' | 'FW_FIBERCOP' | 'TUTTE' | 'NON_APPLICABILE'
  variante: string | null
  componenti: string[]
  prezzo: string | null
  durata: string | null
  dopo: string | null
  attivazione: string | null
  vincolo: string | null
  /** AAAA-MM-GG o null. */
  scadenza: string | null
  note: string[]
  pagina: number | null
}

export interface SkyCanvass {
  /** Chiave dell'IA impostata: senza, il canvass non si può leggere. */
  configurato: boolean
  file: string | null
  etichetta: string | null
  lettoIl: string | null
  controllatoIl: string | null
  /** ok, errore, in_lettura, mai_letto. */
  stato: string
  errore: string | null
  regolaCopertura: string | null
  promo: SkyPromo[]
}

export interface SkyCanvassRefresh {
  /** saltato, invariato, letto, errore. */
  esito: string
  file: string | null
  errore: string | null
  promo: number
  stato: SkyCanvass
}

let cached: { at: number; value: Promise<SkyCanvass> } | null = null

export const skyApi = {
  canvass: () => api<SkyCanvass>('/api/sky/canvass'),
  /** Il canvass cambia una volta al mese: più campi nella stessa pagina lo leggono una volta sola (5 minuti). */
  canvassCached: (): Promise<SkyCanvass> => {
    const now = Date.now()
    if (!cached || now - cached.at > 5 * 60_000) {
      const value = api<SkyCanvass>('/api/sky/canvass')
      cached = { at: now, value }
      value.catch(() => { if (cached?.value === value) cached = null })
    }
    return cached.value
  },
  refreshCanvass: async (): Promise<SkyCanvassRefresh> => {
    const r = await api<SkyCanvassRefresh>('/api/sky/canvass/refresh', { method: 'POST' })
    cached = { at: Date.now(), value: Promise.resolve(r.stato) }
    return r
  },
}
